import { registerRoute, startRouter } from './router';
import { renderLogin } from './pages/login';
import { renderHome } from './pages/home';
import { renderLabsOverview } from './pages/labs-overview';
import { renderLabUpload } from './pages/labs-upload';
import { renderLabReview } from './pages/labs-review';
import { renderMarkerDetail } from './pages/marker-detail';
import { renderSubmission } from './pages/submission';
import { renderMeds } from './pages/meds';
import { renderAgenda } from './pages/agenda';
import { renderCallDetail } from './pages/call-detail';
import { renderNutrition } from './pages/nutrition';
import { renderSettings } from './pages/settings';
import { renderSleepPage } from './pages/sleep';
import { renderTrainingPage } from './pages/training';
import { renderMeasurements } from './pages/measurements';
import { renderDocuments } from './pages/documents';

registerRoute('/login', renderLogin, { auth: 'anonymous' });
registerRoute('/', renderHome);
registerRoute('/labs', renderLabsOverview);
registerRoute('/labs/upload', renderLabUpload);
registerRoute('/labs/upload/:draftId', renderLabReview);
registerRoute('/labs/submission/:date', renderSubmission);
registerRoute('/labs/:markerKey', renderMarkerDetail);
registerRoute('/meds', renderMeds);
registerRoute('/meds/new', renderMeds);
registerRoute('/meds/:id/edit', renderMeds);
registerRoute('/agenda', renderAgenda);
registerRoute('/agenda/:callId', renderCallDetail);
registerRoute('/nutrition', renderNutrition);
registerRoute('/settings', renderSettings);
registerRoute('/sleep', renderSleepPage);
registerRoute('/training', renderTrainingPage);
registerRoute('/measurements', renderMeasurements);
registerRoute('/documents', renderDocuments);

const appRoot = document.getElementById('app');
if (!appRoot) {
  throw new Error('#app element missing');
}
startRouter(appRoot);
